import { LOCALE_KEYS, LocaleCode, LocaleConfigKey, getLocaleCode } from '@/constants/languages';

export interface Translation {
    locale: string;
    field: string;
    content: string;
}

export type FieldTranslationKey<TKey extends string> = {
    [key in TKey]: string;
} & { translations: Translation[] };

//

export function getTranslationsEmpty(fields: string[]): Translation[] {
    return fields.flatMap((field) => LOCALE_KEYS.map((lang) => ({ locale: getLocaleCode(lang), field, content: '' })));
}

//

export function getTranslationsByField(
    field: string,
    content: Record<LocaleConfigKey, string> | Record<LocaleCode, string> | null,
): Translation[] {
    return LOCALE_KEYS.map((lang) => {
        const locale = getLocaleCode(lang);
        // NOTE: "content" could be LocaleConfigKey ({ ES: 'Text', ... }) or LocaleCode ({ es_ES: 'Text', ... })
        // NOTE2: in API, default "Translation" is LocaleConfigKey, and "Notification.message" is LocaleCode
        const localeContent =
            // @ts-expect-error wrong-typed but well-explained
            content?.[lang.toUpperCase() as LocaleConfigKey] ??
            // @ts-expect-error wrong-typed but well-explained
            content?.[locale as LocaleCode] ??
            '';

        return { locale, field, content: localeContent };
    });
}

export function getTranslationsByFields(
    fields: Array<[string, Record<LocaleConfigKey, string> | Record<LocaleCode, string> | null]>,
): Translation[] {
    return fields.flatMap(([field, content]) => getTranslationsByField(field, content));
}
